import React from "react";
import { useTranslation } from "react-i18next";
import "./scss/Contacts.scss";
import { Link } from "react-router-dom";

import phone from "../images/contacts/phone-icon.png";
import email from "../images/contacts/email-icon.png";
import location from "../images/contacts/location-icon.png";

import contactImage from "../images/contacts/contact-flowers.png";

const Contacts = () => {
  const { t } = useTranslation();
  document.title = `Gudema - ${t("pages.contacts")}`;

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted");
  };

  return (
    <main className="contacts-page">
      <section className="contacts-hero">
        <div className="contacts-hero__container">
          <h1>{t("contactsPage.title")}</h1>

          <p>{t("contactsPage.subtitle")}</p>

          <div className="contacts-hero__items">
            <a href="tel:+37067362767">
              <img src={phone} alt="phone" />
              +370 673 62 767
            </a>

            <a href="mailto:info@gudema.lt">
              <img src={email} alt="email" />
              info@gudema.lt
            </a>

            <a
              href="https://maps.google.com/?q=Uosio g. 10, Kaunas, Lietuva, LT-50133"
              target="_blank"
              rel="noreferrer"
            >
              <img src={location} alt="location" />
              Uosio g. 10, Kaunas, Lietuva, LT-50133
            </a>
          </div>
        </div>
      </section>

      <section className="contacts-main">
        <div className="contacts-main__container">
          <div className="contacts-card">
            <img src={contactImage} alt={t("home.title")} />

            <div className="contacts-card__overlay">
              <h2>
                {t("contactsPage.imageTitleLine1")} <br />
                {t("contactsPage.imageTitleLine2")}
              </h2>
            </div>
          </div>

          <form className="contacts-form" onSubmit={handleSubmit}>
            <h2>{t("contactsPage.formTitle")}</h2>

            <div className="contacts-form__grid">
              <input type="text" placeholder={t("common.form.firstName")} required />
              <input type="text" placeholder={t("common.form.lastName")} required />
            </div>

            <input type="tel" placeholder={t("common.form.phone")} />
            <input type="email" placeholder={t("common.form.emailRequired")} required />
            <textarea placeholder={t("contactsPage.commentPlaceholder")} required />

            <label className="contacts-form__terms">
              <input type="checkbox" required />

              <span>
              {t("common.form.termsStart")}{" "}
              <Link to="/privacy" target="_blank" rel="noreferrer">
                {t("common.form.termsServices")}
              </Link>
              .
            </span>
            </label>

            <button type="submit">
              {t("contactsPage.submit")}
              <span>→</span>
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Contacts;
